<template>
  <div>
    <v-row>
      <v-col cols="6" sm="4">
        <FormattedNumberField
          label="Min. Amount"
          :value="minAmountValue"
          :required="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.minAmountValue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="4">
        <FormattedNumberField
          label="Max. Amount"
          :value="maxAmountValue"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.maxAmountValue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="4">
        <FormattedNumberField
          label="Commission"
          :value="commissionPercentValue"
          append-icon="percent"
          :required="true"
          :rules="[isValidPercent]"
          @valueChange="(newValue) => this.commissionPercentValue = newValue"
        ></FormattedNumberField>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    FormattedNumberField
  },
  props: [
    'minAmount',
    'maxAmount',
    'commissionPercent'
  ],
  computed: {
    minAmountValue: {
      get () {
        return this.minAmount
      },
      set (newValue) {
        this.$emit('minAmountChange', newValue)
      }
    },
    maxAmountValue: {
      get () {
        return this.maxAmount
      },
      set (newValue) {
        this.$emit('maxAmountChange', newValue)
      }
    },
    commissionPercentValue: {
      get () {
        return this.commissionPercent
      },
      set (newValue) {
        this.$emit('commissionPercentChange', newValue)
      }
    }
  },
  methods: {
    isValidPercent () {
      return this.commissionPercent >= 0 && this.commissionPercent <= 100 ? true : 'Commission must be between 0 and 100'
    }
  }
}
</script>
